import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Video, Loader2, Trash2, PlayCircle } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const CHUNK = 3 * 1024 * 1024;

export const ShotClip = ({ post, shot, onChange }) => {
  const [progress, setProgress] = useState(null);
  const upload = async (file) => {
    if (!file) return;
    if (file.size > 60 * 1024 * 1024) return toast.error("Clip trop lourd (60 Mo max)");
    const total = Math.ceil(file.size / CHUNK);
    const uploadId = `${post.id}-${shot.n}-${Date.now()}`;
    setProgress(0);
    try {
      let res;
      for (let i = 0; i < total; i++) {
        const fd = new FormData();
        fd.append("upload_id", uploadId); fd.append("index", i); fd.append("total", total); fd.append("filename", file.name); fd.append("content_type", file.type || "video/mp4");
        fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK));
        res = await api.post(`/social/posts/${post.id}/shots/${shot.n}/clip/chunk`, fd, { headers: { "Content-Type": "multipart/form-data" } });
        setProgress(Math.round(((i + 1) / total) * 100));
      }
      onChange(res.data.post);
      toast.success(res.data.all_clips ? "Tous les plans ont leur clip — contenu « Prêt à publier »" : `Clip du plan ${shot.n} joint`);
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Envoi impossible"); }
    finally { setProgress(null); }
  };
  const remove = async () => { const { data } = await api.delete(`/social/posts/${post.id}/shots/${shot.n}/clip`); onChange(data); };

  if (shot.clip_id) return (
    <div className="mt-2 flex items-center gap-2 text-xs" data-testid={`shot-clip-${post.id}-${shot.n}`}>
      <a href={`${API}/media/${shot.clip_id}/file`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-emerald-700 font-medium" data-testid={`shot-clip-link-${post.id}-${shot.n}`}><PlayCircle className="w-4 h-4" /> Clip réel joint{shot.clip_name ? ` · ${shot.clip_name}` : ""}</a>
      <button onClick={remove} className="text-slate-400 hover:text-red-600" data-testid={`shot-clip-remove-${post.id}-${shot.n}`}><Trash2 className="w-3.5 h-3.5" /></button>
    </div>
  );
  return (
    <label className="mt-2 inline-flex items-center gap-2 h-10 px-3 rounded-lg border border-slate-300 bg-white text-xs cursor-pointer hover:bg-slate-50" data-testid={`shot-clip-upload-${post.id}-${shot.n}`}>
      {progress != null ? <Loader2 className="w-4 h-4 animate-spin" /> : <Video className="w-4 h-4" />} {progress != null ? `Envoi ${progress} %` : "Joindre le clip filmé"}
      <input type="file" accept="video/*" capture="environment" className="hidden" disabled={progress != null} onChange={(e) => upload(e.target.files?.[0])} data-testid={`shot-clip-input-${post.id}-${shot.n}`} />
    </label>
  );
};
